<template>
  <Layout>
    <DsIslandsContainer class="body-500">
      <div class="bg-back-layer1">
        <DsSegmentedControl v-model="model">
          <DsSegmentedControlItem v-for="(data, index) in languages" :title="data.label" :key="index">
        <!-- title  -->
        <DsTitle size="h2">
          <span v-html="translateLoc(data.value,'agreement:title')" />
        </DsTitle>
        <!-- agreement  -->
        <div class="px-spacing-500">
          <p v-html="translateLoc(data.value,'agreement:part-1', getUserName, userData.parentIin)">
          </p>
          <p class="mt-spacing-500">
            <ul class="list-decimal pl-7">
              <li v-html="translateLoc(data.value,'agreement:part-2')">
              </li>
              <li v-html="translateLoc(data.value,'agreement:part-3')">
              </li>
              <li v-html="translateLoc(data.value,'agreement:part-4')">
              </li>
                <ul class="list-disc pl-7 mt-spacing-350">
                  <li v-html="translateLoc(data.value,'agreement:part-5')"></li>
                  <li v-html="translateLoc(data.value,'agreement:part-6')"></li>
                  <li v-html="translateLoc(data.value,'agreement:part-7')"></li>
                  <li v-html="translateLoc(data.value,'agreement:part-8')"></li>
                  <li v-html="translateLoc(data.value,'agreement:part-9')"></li>
                  <li v-html="translateLoc(data.value,'agreement:part-10')"></li>
                </ul>
            </ul>
          </p>
          <p class="mt-spacing-500" v-html="translateLoc(data.value,'agreement:part-11')">
          </p>
          <p class="mt-spacing-500" v-html="translateLoc(data.value,'agreement:part-12')">
          </p>
        </div>
          </DsSegmentedControlItem>
        </DsSegmentedControl>
        <DsButtonBar sticky class="z-50">
          <DsButton @click="onCloseClick" size="large">
            <span class="label-600-soft">
              {{ translateLoc(language,'agreement:back-btn') }}
            </span>
          </DsButton>
        </DsButtonBar>
      </div>
    </DsIslandsContainer>
  </Layout>
</template>

<script setup>
import { sendAnalyticEvent } from '@/helpers/sendAnalyticEvent'
import { computed, onBeforeUnmount, ref } from 'vue';
import { getDeviceType } from '@/helpers/getDeviceType';
import translate from "@/filters/translate.filter"
import {
  DsTitle,
  DsButtonBar,
  DsIslandsContainer,
  DsButton,
  DsSegmentedControl,
  DsSegmentedControlItem
} from '@ds/vue2'
import store from '@/store';
import useHeader from '@/composables/useHeader';
import Layout from '@/components/ui/Layout/Layout.vue'

const {setBackFn, setTitle} = useHeader()

setTitle(translate('agreement:header-title'))
setBackFn(() => {
  store.dispatch('goldkidProcess/component', 'start')
})

const language= ref('ru-RU')
const languages = [
  {
    label: 'Рус',
    value: 'ru-RU'
  },
  {
    label: 'Қаз',
    value: 'kk-KZ'
  }
]

const onCloseClick = () => {
  store.dispatch('goldkidProcess/component', 'start')
}


const emit = defineEmits(['input'])

const userData = computed(() => {
  return store.getters['goldkidProcess/userData']
})

const getUserName = computed(() => {
  if (!userData.value.firstName) return '___'
  return `${userData.value?.lastName} ${userData.value?.firstName} ${userData.value?.middleName ? userData.value?.middleName : ''}`
})

onBeforeUnmount(() => {
  sendAnalyticEvent('online_child_gold_collect_data_agreement', {
    started_from: [store.getters['app/urlParams'].startedFrom],
    stage: ['finish'],
    page_path: ['/bank/bpm/products/goldkids/goldkid'],
    external_message_id: [store.getters['goldkidProcess/pId']]
  })
})

</script>

